import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import teamDefault from "./../assets/images/teamDefault.png";
import { useNavigate } from "react-router-dom";
import { colors } from "../values/colors";
import { getTeamProfilePic } from "../uttils/common";
import { TeamScoreboard } from "../models/scoreCard";
import { day_numberMonth_wordsYear } from "../values/dateFormatter";

const MatchCard = (props) => {
  const { enableShadow, customStyles, drawHeaderLine, item, onClick } = props;

  const isScheduled =
    item?.isLive == false &&
    item?.isCompleted == false &&
    item?.isPaused == false;

  const isLive = item?.isLive == true || item?.isPaused == true;
  var matchStatus;
  var matchStatusColor;

  if (isLive) {
    matchStatus = "Live";
    matchStatusColor = colors.red;
  } else if (isScheduled) {
    matchStatus = "Scheduled";
    matchStatusColor = colors.green;
  } else {
    matchStatus = "Results";
    matchStatusColor = colors.darkBlack;
  }
  // let profilePic = getTeamProfilePic(item?.teamA.teamLogo);
  // let seconProfilePic = getTeamProfilePic(item?.teamB.teamLogo);

  let totalRunsA =
    item?.teamAScoreboard?.battingRuns +
    item?.teamAScoreboard?.battingExtraRuns;

  let totalRunsB =
    item?.teamBScoreboard?.battingRuns +
    item?.teamBScoreboard?.battingExtraRuns;

  let calculateTotalRunsA = isNaN(totalRunsA) ? 0 : totalRunsA;
  let calculateTotalRunsB = isNaN(totalRunsB) ? 0 : totalRunsB;

  let totalOversTeamA = 0.0;
  let totalOversTeamB = 0.0;

  const teamScoreboardA = new TeamScoreboard({
    battingCurrentBall: item?.teamAScoreboard?.battingCurrentBall,
  });
  const teamScoreboardB = new TeamScoreboard({
    battingCurrentBall: item?.teamBScoreboard?.battingCurrentBall,
  });
  if (item?.teamAScoreboard?.battingCurrentBall > 0) {
    totalOversTeamA = teamScoreboardA.getTotalOvers();
  }

  if (item?.teamBScoreboard?.battingCurrentBall > 0) {
    totalOversTeamB = teamScoreboardB.getTotalOvers();
  }

  console.log("Live data", item?.teamBScoreboard?.battingCurrentBall);

  return (
    <Card
      variant="outlined"
      sx={[
        {
          boxShadow: enableShadow ? "0px 4px 20px rgba(0, 0, 0, 0.1)" : null,
          m: 2,
          cursor: "pointer",
          borderRadius: "20px",
        },
        customStyles,
      ]}
      onClick={() => onClick(item)}
    >
      <CardContent sx={{ padding: drawHeaderLine ? "0px" : "16px" }}>
        <Stack
          direction={"row"}
          sx={
            drawHeaderLine
              ? { borderBottom: 1, borderColor: "rgba(0, 0, 0, 0.19)" }
              : {}
          }
        >
          <Stack sx={{ flex: 1, padding: drawHeaderLine ? "16px" : "0px" }}>
            <Typography variant="subtitle1">
              {item?.matchName ?? "Loading..."}
            </Typography>
            <Stack direction={"row"} spacing={1} mt={0.5}>
              <Typography variant="subtitle2">
                {" "}
                {day_numberMonth_wordsYear(item?.matchTime)}
              </Typography>
              <Typography variant="subtitle2">
                {item?.city?.name}
                {", "}
                {item?.city?.stateName}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            display={"flex"}
            variant="subtitle1"
            spacing={2}
            sx={{
              padding: drawHeaderLine ? "16px" : "0px",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{ fontSize: "12.40px", color: "#000" }}
              style={{ color: matchStatusColor }}
            >
              {matchStatus}
            </Typography>
          </Stack>
        </Stack>
        <Stack sx={{ padding: drawHeaderLine ? "16px" : "0px" }}>
          <Stack
            direction={"row"}
            mt={2}
            display={"flex"}
            sx={drawHeaderLine ? { alignItems: "center" } : {}}
          >
            <Stack
              display={"flex"}
              sx={{ flex: 1, alignItems: "center" }}
              direction={"row"}
              spacing={1}
            >
              <Stack
                display={"flex"}
                sx={{ flex: 1, alignItems: "center" }}
                direction={"row"}
                spacing={1}
              >
                <img
                  src={teamDefault}
                  style={{ width: "33.84px", height: "33.84px" }}
                />
                <Typography variant="subtitle1">
                  {item?.teamA?.teamName}
                </Typography>
              </Stack>
              <Stack variant="subtitle1" spacing={2}>
                {matchStatus !== "Scheduled" && (
                  <>
                    {item?.teamAScoreboard?.battingCurrentBall == 0 &&
                    matchStatus == "Live" ? (
                      <Typography
                        variant="subtitle2"
                        sx={{ fontSize: "13.53px", color: "#000" }}
                      >
                        Yet To Bat
                      </Typography>
                    ) : (
                      <Stack direction={"row"} spacing={1}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontSize: "13.53px", color: "#000" }}
                        >
                          {`${calculateTotalRunsA}/${
                            item?.teamAScoreboard?.wicketsWhileBatting ?? 0
                          }`}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontSize: "13.53px", color: "#000" }}
                        >
                          {" "}
                          {`(${totalOversTeamA})`}
                        </Typography>
                      </Stack>
                    )}
                  </>
                )}
              </Stack>
            </Stack>
          </Stack>
          <Stack
            direction={"row"}
            mt={2}
            display={"flex"}
            sx={drawHeaderLine ? { alignItems: "center" } : {}}
          >
            <Stack
              display={"flex"}
              sx={{ flex: 1, alignItems: "center" }}
              direction={"row"}
              spacing={1}
            >
              <Stack
                display={"flex"}
                sx={{ flex: 1, alignItems: "center" }}
                direction={"row"}
                spacing={1}
              >
                <img
                  src={teamDefault}
                  style={{ width: "33.84px", height: "33.84px" }}
                />
                <Typography variant="subtitle1">
                  {item?.teamB?.teamName}
                </Typography>
              </Stack>
              <Stack variant="subtitle1" spacing={2}>
                {matchStatus !== "Scheduled" && (
                  <>
                    {item?.teamBScoreboard?.battingCurrentBall == 0 &&
                    matchStatus == "Live" ? (
                      <Typography
                        variant="subtitle2"
                        sx={{ fontSize: "13.53px", color: "#000" }}
                      >
                        Yet To Bat
                      </Typography>
                    ) : (
                      <Stack direction={"row"} spacing={1}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontSize: "13.53px", color: "#000" }}
                        >
                          {`${calculateTotalRunsB}/${
                            item?.teamBScoreboard?.wicketsWhileBatting ?? 0
                          }`}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontSize: "13.53px", color: "#000" }}
                        >
                          {" "}
                          {`(${totalOversTeamB})`}
                        </Typography>
                      </Stack>
                    )}
                  </>
                )}
              </Stack>
            </Stack>
          </Stack>
          <Stack mt={2}>
            <Typography
              style={{ color: matchStatus === "Results" && colors.green }}
              variant="subtitle1"
              sx={{ fontSize: "14.657px", color: "rgba(30, 35, 44, 0.73)" }}
            >
              {item?.overview ?? "...loading"}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MatchCard;
